var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Exclude, Type } from "class-transformer";
import { observable } from "mobx";
export class DocumentRetrievalUIState {
    constructor() {
        this.loadingStart = undefined;
        this.now = undefined;
        this.patientId = null;
        this.studyId = null;
        this.isStatic = false;
        this.hasCompletedStaticLoginCycle = false;
        this.showDocumentSelectionScreen = true;
        this.showFastenImmediately = false;
        this.hasSeenDocumentSelectionScreen = false;
        this.hasSeenRecordsNotFoundScreen = false;
        this.hasDeclinedSharing = false;
        this.currentLocationKeyForLogin = null;
        this.loginRequiredLocationKeys = [];
        this.originalLoginLocationKeys = [];
        this.currentLoginIndex = 0;
        this.completedLoginKeys = [];
        this.skippedLoginKeys = [];
        this.includedLoginKeys = [];
        this.excludedLoginKeys = [];
        this.isInLoginCycle = false;
        this.forceShowRecordsFoundListScreen = false;
        this.pendingSkipLocationKey = null;
        this.isTransitioningToHurLoading = false;
    }
}
__decorate([
    Type(() => Date),
    observable
], DocumentRetrievalUIState.prototype, "loadingStart", void 0);
__decorate([
    Type(() => Date),
    observable
], DocumentRetrievalUIState.prototype, "now", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "patientId", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "studyId", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "isStatic", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "hasCompletedStaticLoginCycle", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "staticRetrievalData", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "showDocumentSelectionScreen", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "showFastenImmediately", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "hasSeenDocumentSelectionScreen", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "hasSeenRecordsNotFoundScreen", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "hasDeclinedSharing", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "currentLocationKeyForLogin", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "loginRequiredLocationKeys", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "originalLoginLocationKeys", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "currentLoginIndex", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "completedLoginKeys", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "skippedLoginKeys", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "includedLoginKeys", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "excludedLoginKeys", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "isInLoginCycle", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "forceShowRecordsFoundListScreen", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "pendingSkipLocationKey", void 0);
__decorate([
    Exclude({ toPlainOnly: true }),
    observable
], DocumentRetrievalUIState.prototype, "isTransitioningToHurLoading", void 0);
__decorate([
    observable
], DocumentRetrievalUIState.prototype, "stepToShow", void 0);
